// extracted by mini-css-extract-plugin
export default {"container":"Advantage_container__vlWB6","wrapper":"Advantage_wrapper__bjfoZ","title":"Advantage_title__XFbq6","icon":"Advantage_icon__wixiD"};